import { DIALOG_DATA } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '@app/components/button/button.component';
import { DialogBase } from '@app/components/dialog/dialog-base';
import { GameActionControls, GamePlayer } from '@app/store/features/games/games.reducer';

export enum LeaveTableOption {
  SitoutNextBB = 1,
  SitoutNexthand,
  LeaveSeat,
  LeaveTable,
}

@Component({
  selector: 'app-game-dialog-leave-table',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ButtonComponent,
  ],
  templateUrl: './game-dialog-leave-table.component.html',
  styleUrl: './game-dialog-leave-table.component.scss',
  host: { class: 'dialog app-game-dialog-leave-table' },
  encapsulation: ViewEncapsulation.None
})
export class GameDialogLeaveTableComponent extends DialogBase {
  leaveTableOption = LeaveTableOption
  constructor(@Inject(DIALOG_DATA) public data: {
    myPlayerSeat: GamePlayer,
    actionControls: GameActionControls,
    isTournament: boolean
  }) {
    super();
  }



  onOption(value?: LeaveTableOption) {
    this.dialogRef.close(value);
  }
}
